// import React from 'react'

// const whisListPage = () => {
//   return (
//     <div>whisListPage</div>
//   )
// }

// export default whisListPage

import React, { useState, useEffect } from "react";
import ProfilePageContent from "../main/profilepageContent/ProfilePageContent";
import Header from "../Global/Header";
import Head from "../Global/Head";
import Footer from "../shared/footer/Footer";
import LoginModal from "../main/loginModal/LoginModal";
import WhisList from "../main/wishList/WhisList";
import { Link } from "react-router-dom";

const WhisListPage = () => {
  const accessToken = localStorage.getItem("@user");
  const [isVisible, setIsVisible] = useState(accessToken ? false : true);
  const [mobileSearchBar, setMobileSearchBar] = useState(false);
  const [topPosition, setTopPosition] = useState(50);

  useEffect(() => {
    let interval;
    const totalTime = 1500;
    const steps = 800;
    const intervalTime = totalTime / steps;
    const decrement = 1300 / steps;

    const increment = 1300 / steps;

    if (isVisible) {
      interval = setInterval(() => {
        setTopPosition((prev) => {
          if (prev <= 0) {
            clearInterval(interval);
            return 0;
          }
          return prev - decrement;
        });
      }, intervalTime);
    } 

    return () => clearInterval(interval);
  }, [isVisible]);

  const slideGoDown = () => {
    const totalTime = 1500; // Total animation time
    const steps = 800; // Number of steps
    const intervalTime = totalTime / steps; // Time per step
    const increment = 1300 / steps; // Position change per step

    let interval = setInterval(() => {
      setTopPosition((prev) => {
        if (prev >= 80) {
          clearInterval(interval); // Stop the interval
          setTimeout(() => setIsVisible(false), 0); // Change state after animation ends
          return 80; // Ensure it stops at the original position
        }
        return prev + increment; // Increment position to slide down
      });
    }, intervalTime);
  };

  const BlankModal = ({ isVisible, setIsVisible }) => {
    return (
      <div
        className={`fixed inset-0 z-[1000]  transition-opacity duration-300 ${
          isVisible ? "opacity-100 visible" : "opacity-0 invisible"
        }`}
      >
        <div
          className="absolute inset-0 login-slide-up  bg-black"
          onClick={() => setIsVisible(false)}
        ></div>
        <div className="relative w-full h-screen">
          <div
            style={{ top: `${topPosition}%` }} // Dynamic top position
            className="absolute w-full h-screen transition-none"
          >
            <LoginModal setIsVisible={setIsVisible} slideGoDOwn={slideGoDown} />
          </div>
        </div>
      </div>
    );
  };
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top
  }, []); // Run on mount

  return (
    <>
     <div className="hidden sm:inline">
        <Head />
        <Header setIsVisible={setIsVisible} />
      </div>
      <BlankModal setIsVisible={setIsVisible} isVisible={isVisible} />
      <Link to={"/mobileSearch"} className="sm:hidden stickynav-custom">
          <div style={{ pointerEvents: "none" }}>
            <Head />
            <Header setIsVisible={setIsVisible} />
          </div>
        </Link>
      <WhisList />
      <Footer />
    </>
  );
};

export default WhisListPage;
